import { render, staticRenderFns } from "./FooterContactBlock.vue?vue&type=template&id=8a595cd0&"
import script from "./FooterContactBlock.vue?vue&type=script&lang=coffee&"
export * from "./FooterContactBlock.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports